import { useEffect, useState, useRef } from "react";
import { useAppDispatch } from "../../hooks/storeHooks";
import { fetchAllMastersForMocks } from "../../store/slices/detailedMaster/detailedMasterSlice";
import MockMangements from "./MockMangements";
import { getServerEnvironment } from "../../store/slices/constants/staticContents";

function MockMangementsContainer({ hierarchy, onSubmit, onClose }: any) {
  const [filters, setFilters] = useState<any>({
    question_status: "untagged",
  });
  const [expandedMap, setExpandedMap] = useState<any>({});
  const [pagination, setPagination] = useState<any>({
    series: 1,
    tests: 1,
    section: 1,
    question: 1,
  });
  useEffect(() => {
    try {
      const stored = localStorage.getItem(
        btoa(`${getServerEnvironment()}-mock-test`)
      );
      if (stored) {
        const decoded = atob(stored);
        const parsed = JSON.parse(decoded);
        console.log(parsed.filters, parsed.expandedMap, "parsedparsed");
        if (parsed.expandedMap) {
          setExpandedMap(parsed.expandedMap);
        }
        if (parsed.filters) {
          setFilters(parsed.filters);
        }
        if (parsed.pagination) {
          setPagination(parsed.pagination);
        }
        // if (Array.isArray(parsed) && parsed.length > 0) {
        //   setExpandedMap(parsed);
        // }
      }
    } catch (err) {
      console.warn("Error reading copied data:", err);
    }
  }, []);
  useEffect(() => {
    try {
      console.log(filters, "parsedparsed");
      const encoded = btoa(
        unescape(
          encodeURIComponent(
            JSON.stringify({
              filters: filters,
              expandedMap: expandedMap,
              pagination: pagination,
            })
          )
        )
      );
      localStorage.setItem(
        btoa(`${getServerEnvironment()}-mock-test`),
        encoded
      );
    } catch (err) {
      console.warn("Error reading copied data:", err);
    }
  }, [filters, expandedMap, pagination]);
  const dispatch = useAppDispatch();
  const prevFiltersRef = useRef<any>({});
  useEffect(() => {
    dispatch(fetchAllMastersForMocks({ level: "series" }));
  }, [dispatch]);
  useEffect(() => {
    const prevFilters = prevFiltersRef.current;

    const fetchSequentially = async () => {
      try {
        const shouldRefetchAll = [
          "seriesrefetch",
          "mocktestrefetch",
          "sectionrefetch",
          "questionrefetch",
        ].some((key) => filters[key] !== prevFilters[key]);
        console.log(shouldRefetchAll, filters, prevFilters, "prevFilters");
        if (shouldRefetchAll) {
          // run all APIs in sequence
          await dispatch(fetchAllMastersForMocks({ level: "series" })).unwrap();
          if (filters.series)
            await dispatch(
              fetchAllMastersForMocks({
                level: "mocktest",
                parent_id: filters.series,
              })
            ).unwrap();
          if (filters.mocktest)
            await dispatch(
              fetchAllMastersForMocks({
                level: "section",
                parent_id: filters.mocktest,
              })
            ).unwrap();
          if (filters.section)
            await dispatch(
              fetchAllMastersForMocks({
                level: "question",
                parent_id: filters.section,
                status:
                  filters.question_status === "untagged"
                    ? "pending"
                    : "reviewed",
              })
            ).unwrap();
        } else {
          // Only fetch APIs affected by changed main filter
          if (filters.series !== prevFilters.series) {
            await dispatch(
              fetchAllMastersForMocks({
                level: "mocktest",
                parent_id: filters.series,
              })
            ).unwrap();
          }
          if (filters.mocktest !== prevFilters.mocktest) {
            await dispatch(
              fetchAllMastersForMocks({
                level: "section",
                parent_id: filters.mocktest,
              })
            ).unwrap();
          }
          if (
            filters.section !== prevFilters.section ||
            filters.question_status !== prevFilters.question_status
          ) {
            await dispatch(
              fetchAllMastersForMocks({
                level: "question",
                parent_id: filters.section,
                status:
                  filters.question_status === "untagged"
                    ? "pending"
                    : "reviewed",
              })
            ).unwrap();
          }
        }
      } catch (err) {
        console.error("Error fetching content:", err);
      }
    };

    fetchSequentially();
    prevFiltersRef.current = filters;
  }, [filters, dispatch]);
  //  pagination.QUESTION

  return (
    <MockMangements
      hierarchy={hierarchy}
      setFilters={setFilters}
      setExpandedMap={setExpandedMap}
      expandedMap={expandedMap}
      setPagination={setPagination}
      pagination={pagination}
      onSubmit={onSubmit}
      onClose={onClose}
      filters={filters}
    />
  );
}

export default MockMangementsContainer;
